import React from "react";
import { MINESHAFT_GREY } from "@/constants/colors";

const CloseIcon = ({ color = MINESHAFT_GREY }) => (
  <svg
    version="1.2"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 17 18"
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    width="15"
  >
    <g transform="translate(1 1)">
      <g fillRule="evenodd" fill="none" id="Payment-Details-/-Receipt_1546638005488">
        <g
          fillRule="nonzero"
          fill={color}
          transform="translate(-929 -270)"
          id="Payments-Details---View-Receipt_1546638005488"
        >
          <g transform="translate(472 240)" id="Group-14_1546638005488">
            <g transform="translate(457 30)" id="Group_1546638005488">
              <rect
                height="18"
                width="3"
                y="-1"
                x="6"
                transform="rotate(45 7.5 8)"
                id="Rectangle_1546638005488"
                vectorEffect="non-scaling-stroke"
              />
              <rect
                height="18"
                width="3"
                y="-1"
                x="6"
                transform="rotate(-45 7.5 8)"
                id="Rectangle-Copy-2_1546638005488"
                vectorEffect="non-scaling-stroke"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CloseIcon;
